import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// Fonts are bundled (no requests to Google: privacy / GDPR)
import '@fontsource/antonio/latin-400.css';
import '@fontsource/antonio/latin-600.css';
import '@fontsource/antonio/latin-700.css';
import '@fontsource/barlow/latin-400.css';
import '@fontsource/barlow/latin-400-italic.css';
import '@fontsource/barlow/latin-500.css';
import '@fontsource/barlow/latin-600.css';
import '@fontsource/barlow/latin-700.css';
import '@fontsource/gayathri/latin-400.css';
import '@fontsource/gayathri/latin-700.css';
import './styles.css';
import './app.css';
import './lib/install'; // catches the browser's "can be installed" announcement as early as possible
import App from './App';
import { ToastProvider } from './ui';

const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: 1, refetchOnWindowFocus: true, staleTime: 30_000 } },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <App />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
);

// installable app + push: the service worker only handles notifications (no offline cache)
if ('serviceWorker' in navigator)
  window.addEventListener('load', () => {
    void navigator.serviceWorker
      .register(`${import.meta.env.BASE_URL}sw.js`, { scope: import.meta.env.BASE_URL })
      .catch(() => {});
  });
